


























































































































































import { computed, defineComponent, ref } from '@vue/composition-api';
import { useGetReminders } from './reminders.hook';
import { useMembershipInfo } from '../../components/utils/membership-info';
import { SQTable, SQMainHeader } from '../../components/base';
import { useStore } from '../../composables';
import ESidebarUpdate from './modals/ESidebarUpdate.vue';
import ESidebarCreate from './modals/ESidebarCreate.vue';
import { AlertModal } from '../../components/base';
import { useReminderManager } from './reminder-manager.hook';
import { APrimaryBtn, ASecondaryBtn } from '../../components/base/app/buttons/';
import { Event } from '@ligo/dashboard/customer/store';

export default defineComponent({
  name: 'ReminderList',
  components: {
    APrimaryBtn,
    ASecondaryBtn,
    AlertModal,
    ESidebarUpdate,
    ESidebarCreate,
    SQTable,
    SQMainHeader
  },
  props: {
    query: Object,
    externalLoading: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { root, emit }) {
    const {
      totalReminders,
      pagination,
      loading,
      columns,
      rows,
      actions,
      filters,
      remindersList,
      showConfirmationDialog,
      selectedReminder,
      search,
      getReminders
    } = useGetReminders(props.query || {}, emit);

    const { membershipTypeSlug } = useMembershipInfo();

    const {
      createUnlinkedReminder,
      eventUpdate,
      eventDelete,
      eventComplete,
      remindMeOnCustomTime
    } = useReminderManager();

    const store = useStore();
    const user = computed(() => store.getters['authentication/user']);

    const isSelectedReminderRecurrent = computed(() => {
      return (
        selectedReminder.value?.event_type?.recurrence &&
        selectedReminder.value?.event_type?.recurrence != 'not_recurrent'
      );
    });

    const deleteReminderCallback = ref();

    const showESidebarUpdate = ref(false);
    const showESidebarCreate = ref(false);

    function trackTaskAction(label: string, reminder: Event) {
      (window as any).analytics.track(`Reminder - ${label}`, {
        email: user.value.email,
        uuid: user.value.uuid,
        created_at: reminder.created_at,
        assignees: reminder.employees.length,
        event_date: reminder.event_date,
        remind_on: reminder.remind_me_on,
        membership: membershipTypeSlug,
        event_type: reminder.event_type?.slug,
        visible: reminder.visible
      });
    }

    function onShowUpdateModal(reminderId: number) {
      const reminder = remindersList.value.find(
        (reminder) => reminder.id === reminderId
      );
      trackTaskAction('opened', reminder);
      selectedReminder.value = reminder;
      root.$nextTick(() => {
        showESidebarUpdate.value = true;
      });
    }

    function finishUpdateAction() {
      getReminders();
      showESidebarUpdate.value = false;
    }

    function finishCreateAction() {
      getReminders();
      showESidebarCreate.value = false;
    }

    function onToggleCompleteReminder(reminderId: number) {
      const reminder = remindersList.value.find(
        (reminder) => reminder.id === reminderId
      );
      eventComplete(reminder.id, getReminders);
    }

    function onDeleteReminder(reminderId: number) {
      const reminder = remindersList.value.find(
        (reminder) => reminder.id === reminderId
      );
      selectedReminder.value = reminder;
      showConfirmationDialog.value = true;
      deleteReminderCallback.value = () => {
        eventDelete(reminder.id, getReminders);
        showConfirmationDialog.value = false;
      };
    }

    function onUpdateReminder(reminder: Event) {
      eventUpdate(reminder, finishUpdateAction);
    }

    function onRemindMeOnCustomTime(reminder, opt) {
      const onCloned = () => {
        trackTaskAction('cloned', reminder);
        finishUpdateAction();
      };
      remindMeOnCustomTime({ ...reminder }, opt, onCloned);
    }

    return {
      totalReminders,
      pagination,
      filters,
      actions,
      columns,
      rows,
      isSelectedReminderRecurrent,
      loading,
      deleteReminderCallback,
      selectedReminder,
      showConfirmationDialog,
      showESidebarCreate,
      showESidebarUpdate,
      onRemindMeOnCustomTime,
      search,
      onUpdateReminder,
      finishCreateAction,
      createUnlinkedReminder,
      finishUpdateAction,
      onShowUpdateModal,
      onToggleCompleteReminder,
      onDeleteReminder
    };
  }
});
